import { render, staticRenderFns } from "./PregaoValor.vue?vue&type=template&id=22e2b99c&scoped=true&"
import script from "./PregaoValor.vue?vue&type=script&lang=js&"
export * from "./PregaoValor.vue?vue&type=script&lang=js&"
import style0 from "./PregaoValor.vue?vue&type=style&index=0&id=22e2b99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2b99c",
  null
  
)

export default component.exports